import { GET_JOBCARDTYPE_REQUEST, GET_JOBCARDTYPE_SUCCESS, GET_JOBCARDTYPE_FAIL, GET_VEHICLENO_REQUEST, GET_VEHICLENO_SUCCESS, GET_VEHICLENO_FAIL } from '../types/inputApiTypes';
import Axios from 'axios';
import APP_CONSTANT from '../../config/constants'   


export const getJobCardType = () => async (dispatch) => {
    dispatch({ type: GET_JOBCARDTYPE_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId')
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}public/api/jobcardtype/getTypes`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_JOBCARDTYPE_SUCCESS, payload: data });
        console.log('JobCardType Data: ', data)
    } catch (error) {
        dispatch({ type: GET_JOBCARDTYPE_FAIL, payload: error.message })
    }
}

export const getVehicleNo = () => async (dispatch) => {
    dispatch({ type: GET_VEHICLENO_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNumber": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId')
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}masters/vehicleMaster/`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_VEHICLENO_SUCCESS, payload: data });
        console.log('VehicleNo Data: ', data)
    } catch (error) {
        dispatch({ type: GET_VEHICLENO_FAIL, payload: error.message })
    }
}
